import { Injectable } from '@angular/core';
import {SCMProject} from '../../../models/SCMProject';
import {Observable} from 'rxjs';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {ProjectService} from '../../../services/project.service';

@Injectable()
export class ProjectResolver implements Resolve<SCMProject> {

    resolve(route: ActivatedRouteSnapshot): Observable<SCMProject> {

        if (!route.params['projectId']) {
            throw new Error('Route parameter projectId must be set to use ProjectResolver');
        }

        return this.projectService.getProject(route.params['projectId']);

    }

    constructor(private projectService: ProjectService) { }
}
